<div class="switcher">
  <p-toggleswitch inputId="{{ id }}" [(ngModel)]="checked" (onChange)="onChecked($event)" />
  @if (label) {
    <label for="{{ id }}">{{ label }}</label>
  }
  <ng-content />
</div>
